import React, { lazy } from 'react';

import { withFeatureFlag } from '../hooks/Helper.js';
const Stores = lazy(() => import('../pages/inventory/stores'));
const Categories = lazy(() => import('../pages/inventory/categories'));
const Products = lazy(() => import('../pages/inventory/products'));
const ProductDetail = lazy(() => import('../pages/inventory/productDetail'));
const ProductData = lazy(() => import('../pages/inventory/productData'));
const ProductPricing = lazy(() => import('../pages/inventory/productPricing'));
const ProductImages = lazy(() => import('../pages/inventory/productImages'));
const ProductVariants = lazy(() => import('../pages/inventory/productVariants'));
const ProductBom = lazy(() => import('../pages/inventory/productBom'));
const NewProduct = lazy(() => import('../pages/inventory/newProduct'));

const ProductSubscription = lazy(
  () => import('../pages/inventory/productSubscription.jsx')
);

const ProductServices = lazy(() => import('../pages/inventory/productServices'));
const Coupons = lazy(() => import('../pages/inventory/coupon'));
const ProductEvent = lazy(() => import('../pages/inventory/productEvent'));

const routes = [
  {
    path: 'coupons',
    element: <Coupons />,
  },
  {
    path: 'stores',
    element: <Stores />,
  },
  {
    path: 'categories',
    element: <Categories />,
  },
  {
    path: 'products',
    element: <Products />,
  },
  {
    path: 'products/new',
    element: <NewProduct />,
  },
  {
    path: 'products/:productId/general',
    element: <ProductDetail />,
  },
  {
    path: 'products/:productId/data',
    element: <ProductData />,
  },
  {
    path: 'products/:productId/pricing',
    element: <ProductPricing />,
  },
  {
    path: 'products/:productId/variants',
    element: <ProductVariants />,
  },
  {
    path: 'products/:productId/images',
    element: <ProductImages />,
  },
  {
    path: 'products/:productId/bom',
    element: <ProductBom />,
  },
  {
    path: 'products/:productId/subscription',
    element: <ProductSubscription />,
  },
  {
    path: 'products/:productId/services',
    element: <ProductServices />,
  },
  {
    path: 'products/:productId/event',
    element: <ProductEvent />,
  },
];

export default routes;
